export const usePublicStore = defineStore("public", () => {

  const fetchProjectList = async () => {
    try {
      return await $fetch(`/api/public/projects`, {
        headers: { "Content-type": "application/json" },
        method: "GET",
      })
    } catch (error) {
      console.error("Failed to get projects:", error.data)
      return { error: true, ...error.data.data }
    }
  }

  const getPublicProject = async (projectId) => {
    try {
      return await $fetch(`/api/public/projects/${projectId}`, {
        headers: { "Content-type": "application/json" },
        method: "GET",
      })
    } catch (error) {
      console.error("Failed to get project:", error.data)
      return { error: true, ...error.data.data }
    }
  }

  const fetchPublicReports = async (projectId) => {
    try {
      return await $fetch(`/api/public/reports/${projectId}`, {
        headers: { "Content-type": "application/json" },
        method: "GET",
      })
    } catch (error) {
      console.error("Failed to fetch public reports:", error.data)
      return { error: true, ...error.data.data }
    }
  }

  return {
    fetchProjectList,
    getPublicProject,
    fetchPublicReports
  }
})
